import { BASE_ENDPOINT } from "../../../endpoint";

export const retrieveDisbursedLoanReportService = async (
	token: string,
	filters: { [key: string]: string },
	pagination?: {
		page: string;
		perPage: string;
	},
) => {
	let queryParams = new URLSearchParams(filters).toString();
	if (pagination) {
		queryParams += `&page=${pagination.page}&perPage=${pagination.perPage}`;
	}
	try {
		const response = await fetch(
			`${BASE_ENDPOINT}/user/report/disbursedloan?${queryParams}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			},
		);
		const res = await response.json();
		if (!response.ok) {
			console.error("Error:", res);
			throw new Error(res.message);
		}
		return res;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
